__turbopack_context__.v({
  "navButton": "_5UZ_TW_navButton",
  "navItemButton": "_5UZ_TW_navItemButton",
});
